// extracted by mini-css-extract-plugin
module.exports = {"group__label":"RadioGroup_group__label__Qmk17"};